import styled, {css} from 'styled-components'

export const StyledAgendaDateRoomFields = styled.div<{$columns?: number}>(
    ({theme: {spacing}, $columns = 4}) => css`
        display: grid;
        grid-template-columns: repeat(${$columns}, 1fr);
        gap: ${spacing * 4}px;
        width: 100%;
    `
)
